  (function() {
    const style = document.createElement('style');
    style.textContent = `
      .nav li a[href]:not([href="#"]) {
        opacity: 0;
        transition: opacity 0.3s ease;
      }
      
      body.js-nav-loaded .nav li a[href]:not([href="#"]) {
        opacity: 1;
      }
      
      .nav li a[href]:not([href="#"]):not(.js-processed) {
        visibility: hidden;
      }
    `;
    document.head.appendChild(style);
  })();

  document.addEventListener('DOMContentLoaded', function() {
    const nav = document.querySelector('.nav');
    if (!nav) {
      document.body.classList.add('js-nav-loaded');
      return;
    }
    
    const menuItems = Array.from(nav.querySelectorAll('li'));
    
    const menuStructure = {};
    let lastMainMenu = null;
    
    menuItems.forEach(function(item) {
      const link = item.querySelector('a');
      if (!link) return;
      
      link.classList.add('js-processed');
      
      const text = link.textContent.trim();
      
      if (text.startsWith('-')) {
        item.remove();
        
        if (lastMainMenu) {
          if (!menuStructure[lastMainMenu.text]) {
            menuStructure[lastMainMenu.text] = [];
          }
          
          menuStructure[lastMainMenu.text].push({
            text: text.replace(/^-\s*/, ''),
            url: link.getAttribute('href')
          });
        }
      } else {
        lastMainMenu = {
          text: text,
          url: link.getAttribute('href'),
          element: item
        };
      }
    });
    
    for (const mainMenuText in menuStructure) {
      const mainMenu = menuItems.find(item => {
        const link = item.querySelector('a');
        return link && link.textContent.trim() === mainMenuText && !item.parentNode.matches('.dropdown-menu');
      });
      
      if (mainMenu && menuStructure[mainMenuText].length > 0) {
        mainMenu.classList.add('has-dropdown');
        
        const mainLink = mainMenu.querySelector('a');
        
        mainLink.innerHTML = `
          ${mainMenuText}
          <span class="dropdown-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
            </svg>
          </span>
        `;
        
        const submenu = document.createElement('ul');
        submenu.className = 'dropdown-menu';
        
        menuStructure[mainMenuText].forEach(function(subMenu) {
          const li = document.createElement('li');
          li.innerHTML = `<a href="${subMenu.url}" class="js-processed">${subMenu.text}</a>`;
          submenu.appendChild(li);
        });
        
        mainMenu.appendChild(submenu);
        
        mainLink.addEventListener('click', function(e) {
          if (window.innerWidth <= 767) {
            e.preventDefault();
            mainMenu.classList.toggle('open');
          }
        });
      }
    }
    
    const style = document.createElement('style');
    style.textContent = `
      .nav .has-dropdown {
        position: relative;
      }
      
      .dropdown-arrow {
        display: inline-block;
        margin-left: 5px;
        vertical-align: middle;
      }
      
      .dropdown-arrow svg {
        width: 12px;
        height: 12px;
        transition: transform 0.3s ease;
      }
      
      .nav .has-dropdown:hover .dropdown-arrow svg,
      .nav .has-dropdown.open .dropdown-arrow svg {
        transform: rotate(180deg);
      }
      
      .nav .has-dropdown .dropdown-menu {
        display: none;
        position: absolute;
        top: 100%;
        left: 0;
        width: auto;
        white-space: nowrap;
        background: #fff;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        padding: 8px 0;
        margin: 0;
        list-style: none;
        z-index: 100;
      }
      
      .nav .has-dropdown:hover .dropdown-menu {
        display: block;
      }
      
      .nav .has-dropdown .dropdown-menu li {
        padding: 0;
        margin: 0;
        display: block !important;
        width: 100%;
      }
      
      .nav .has-dropdown .dropdown-menu li a {
        display: block;
        padding: 8px 16px;
        color: #333;
        font-size: 14px;
        line-height: 1.5;
        text-decoration: none;
        transition: background 0.2s ease;
        white-space: nowrap;
      }
      
      .nav .has-dropdown .dropdown-menu li a:hover {
        background: rgba(0, 0, 0, 0.05);
      }
      
      @media (max-width: 767px) {
        .gh-navigation-menu .gh-search.gh-icon-button,
        .gh-navigation-menu button.gh-search.gh-icon-button {
          display: none !important;
        }
        
        .gh-navigation-menu {
          width: 100% !important;
          max-width: 100% !important;
          padding: 0 !important;
        }
        
        .gh-navigation-menu .nav {
          width: 100% !important;
          display: flex !important;
          flex-direction: column !important;
        }
        
        .gh-navigation-menu .nav li {
          width: 100% !important;
          text-align: left !important;
        }
        
        .gh-navigation-menu .nav li a {
          display: block !important;
          width: 100% !important;
          padding: 12px 20px !important;
        }
        
        .nav .has-dropdown .dropdown-menu {
          position: static;
          box-shadow: none;
          width: 100% !important;
          padding-left: 20px;
          background: transparent;
          border-radius: 0;
          white-space: normal;
        }
        
        .nav .has-dropdown:hover .dropdown-menu {
          display: none;
        }
        
        .nav .has-dropdown.open .dropdown-menu {
          display: block;
        }
        
        .nav .has-dropdown > a {
          position: relative;
        }
        
        .nav .has-dropdown .dropdown-arrow {
          position: absolute;
          right: 20px;
          top: 50%;
          transform: translateY(-50%);
        }
        
        .nav .has-dropdown.open .dropdown-arrow svg {
          transform: translateY(-50%) rotate(180deg);
        }
        
        .gh-navigation.is-open .gh-navigation-inner {
          width: 100% !important;
          max-width: 100% !important;
        }
        
        .gh-navigation.is-open .gh-navigation-menu {
          width: 100% !important;
          max-width: 100% !important;
        }
      }
    `;
    document.head.appendChild(style);
    
    document.body.classList.add('js-nav-loaded');
  });